import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../../components/dashboard/DashboardLayout';
import { QRCodeEditForm } from '../../components/qr/QRCodeEditForm';
import { sampleQRCodeDetailResponse, SAMPLE_QR_SHORT_CODE } from '../../data/sampleQrCode';

// Counterpart to QRCodeEditPage.tsx for the demo QR code: same form, same
// routing-rules editor, fully interactive — but readOnly on QRCodeEditForm
// short-circuits the save mutation, since there's no real backend row.
export default function SampleQRCodeEditPage() {
  const navigate = useNavigate();
  const goBack = () => navigate(`/dashboard/qr-codes/${SAMPLE_QR_SHORT_CODE}`);

  return (
    <DashboardLayout currentPage="qr-codes">
      <QRCodeEditForm
        initialData={sampleQRCodeDetailResponse}
        onBack={goBack}
        readOnly
      />
    </DashboardLayout>
  );
}
